import { supabase } from '@/integrations/supabase/client';

export const uploadReceiptToStorage = async (file: File): Promise<string> => {
  // Generate unique filename
  const fileExt = file.name.split('.').pop();
  const fileName = `${Date.now()}-${Math.random().toString(36).substring(2)}.${fileExt}`;
  const filePath = `receipts/${fileName}`;

  const { data, error } = await supabase.storage
    .from('expense-receipts')
    .upload(filePath, file);

  if (error) {
    throw new Error(`Error uploading file: ${error.message}`);
  }

  // Get public URL
  const { data: { publicUrl } } = supabase.storage
    .from('expense-receipts')
    .getPublicUrl(filePath);

  return publicUrl;
};

export const deleteReceiptFromStorage = async (url: string): Promise<void> => {
  try {
    // Extract file path from URL
    const urlParts = url.split('/');
    const fileName = urlParts[urlParts.length - 1];
    const filePath = `receipts/${fileName}`;

    const { error } = await supabase.storage
      .from('expense-receipts')
      .remove([filePath]);

    if (error) {
      console.error('Error deleting file:', error);
    }
  } catch (error) {
    console.error('Error parsing file URL:', error);
  }
};